import { Suspense } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "@babackapp/auth-client/hooks";
import ReturnTemplatesEditor from "@babackapp/templates-editor/return-templates-editor";

export default function ReturnEmailTemplateEditorPage() {
  const { shopId, templateId } = useParams<{
    shopId: string;
    templateId: string;
  }>();
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!shopId || !templateId) return null;

  return (
    <Suspense fallback={null}>
      <div className="absolute inset-0">
        <ReturnTemplatesEditor
          shopId={shopId}
          currentTemplateId={templateId}
          currentUserEmail={user?.emails?.[0]?.address}
          openTemplate={(id) =>
            navigate(`/shops/${shopId}/settings/notifications/email-templates/${id}`)
          }
          devMode={import.meta.env.DEV}
        />
      </div>
    </Suspense>
  );
}
